import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { sharedDynamicsMetadata } from '../consts/metadata-consts';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { getDataflowDynamicsSink, getDataflowDynamicsSource, onetimeQueryTemplate } from './dynamics-metadata';
import { ConnectionAuthKind } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { compact } from 'lodash';

export const commonDataServiceMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.commonDataService.linkedServiceType,
        displayName: __IS_FABRIC_DPE__ ? stringResources.Dataverse_DisplayText : stringResources.CommonDataService_DisplayText,
        linkedServiceNamePrefix: 'Dataverse',
        linkedServiceKind: 'table',
        icon: {
            className: 'svg-i-100x100-Dataverse'
        },
        supportedInTrident: true,
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        supportOPDG: GlobalVariables.enableOPDG,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: ResourceKind.CommonDataService
        },
        supportedAuthKindsInTrident: compact([
            ConnectionAuthKind.ServicePrincipal,
            ConnectionAuthKind.WorkspaceIdentity,
            ConnectionAuthKind.OAuth2
        ]),
        supportCopyJobSource: true,
        supportCopyJobSink: true,
        supportedJobModesAsSource: GlobalVariables.copyJobIncrementalCopyPhase2 ? undefined : ['Batch'],
        isFirstClass: true,
        supportDatasetV2: true,
        supportDataFlowSource: true,
        supportDataFlowSink: true,
        supportFirstClassParameterExperience: true,
        dataflowSource: [getDataflowDynamicsSource(DatasetFormatType.Dataverse, adfModelTypeMap.commonDataService.dataflowSettings)],
        dataflowSink: [getDataflowDynamicsSink(DatasetFormatType.Dataverse, adfModelTypeMap.commonDataService.dataflowSettings)],
        tableNameAlias: 'entityName',
        onetimeQueryTemplate,
        timedQueryTemplate: '<fetch>\n'
            + '<entity name="<<tableName>>">\n'
            + '<all-attributes />\n'
            + '<filter type="and">\n'
            + '<condition attribute ="<<columnName>>" operator="between">\n'
            + '<value>@{formatDateTime(pipeline().parameters.windowStart, \'yyyy-MM-dd HH:mm\')}</value>\n'
            + '<value>@{formatDateTime(pipeline().parameters.windowEnd, \'yyyy-MM-dd HH:mm\')}</value>\n'
            + '</condition>\n'
            + '</filter>\n'
            + '</entity>\n'
            + '</fetch>\n',
        deltaLoadQueryTemplate: '<fetch>\n'
            + '<entity name="<<tableName>>">\n'
            + '<all-attributes />\n'
            + '<filter type="and">\n'
            + '<condition attribute ="<<columnName>>" operator="between">\n'
            + '<value><<startValue>></value>\n'
            + '<value><<endValue>></value>\n'
            + '</condition>\n'
            + '</filter>\n'
            + '</entity>\n'
            + '</fetch>\n',
        fetchTableNameFromItemPath: true,
        copySinkTypes: [adfModelTypeMap.commonDataService.copySinkType],
        copySourceTypes: [adfModelTypeMap.commonDataService.copySourceType],
        category: ['ServicesApps'],
        controls: sharedDynamicsMetadata
    };

    return metadata;
};
